import Workspace from '../../workspaces';

const saveSnapshotDialog = () => {
    const $container = $(document.createElement('div'));
    $container.appendTo('body');

    const onClose = () => {
        kendoPropmt.destroy();
        $container.remove();
    };
    const kendoPropmt = $container.kendoPrompt({
        width: '240px',
        title: false,
        closable: false,
        modal: false,
        content: 'Informe o nome da sessão: ',
        close: onClose,
    }).data('kendoPrompt').open();

    kendoPropmt.result.done((name) => {
        Workspace.create(name);
        Workspace.setPrincipal(name);
        Workspace.save();
    });
};

export default saveSnapshotDialog;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/snapshot-save.js